import { usePotentiallyAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'

/*
   Note(Diego): This is a quick feature flag substitute for work in progress that you don't want people
   to see in production.
   It will only return true if you are in "localhost" or if you are in production in the deployed
   app but in Omnea QA env only.
   The reason this doesn't rely on the "isOmnean" property is because sales/customer team may demo the app
   to customers and show them parts of the system that are in progress.
 */
export const useOnlyAvailableInLocalAndQa = (): boolean => {
  const { org } = usePotentiallyAuthenticatedUser()
  const omneaQaOrgIdInProd = 'aeee20a4-ffec-4072-93d2-fa6f6c1251a5'
  if (typeof window !== 'undefined') {
    const isLocalhost = window.location.hostname === 'localhost'
    return isLocalhost || omneaQaOrgIdInProd === org?.organisationId
  }

  return false
}
